<div fxLayout="column" fxFill>
	<nc-main-content>
		<nc-pdf-viewer [url]="pdfUrl" [language]="language" [fileName]="fileName"> </nc-pdf-viewer>
	</nc-main-content>
	<ea-footer onCancelLabel="back" [onCancel]="onBack"> </ea-footer>
</div>
